/**
 * Canonical readiness state (backend-authoritative).
 * UI must never infer readiness from partial signals; only render based on this field.
 * If missing or undefined, treat as warming_up.
 */

export type ReadinessState =
  | 'provisional'
  | 'connecting'
  | 'warming_up'
  | 'learning'
  | 'ready'
  | 'degraded';

const VALID_STATES: ReadinessState[] = [
  'provisional',
  'connecting',
  'warming_up',
  'learning',
  'ready',
  'degraded',
];

export function getReadinessState(
  property: { readiness_state?: string | null } | null | undefined
): ReadinessState {
  const raw = property?.readiness_state;
  if (raw == null || raw === '') return 'warming_up';
  const s = raw as ReadinessState;
  return VALID_STATES.includes(s) ? s : 'warming_up';
}

export function isReady(state: ReadinessState): boolean {
  return state === 'ready';
}

export function showReadinessBanner(state: ReadinessState): boolean {
  return state !== 'ready';
}
